


































import Vue from 'vue';
import Autocomplete from '@/components/Autocomplete/index.vue';

export default Vue.extend({
  name: 'Queue',
  components: {
    Autocomplete,
  },
  data() {
    return {
      showInput: false as boolean,
      newCountry: '' as string,
      time: null as number | null,
      warn: {
        time: false as boolean,
        country: false as boolean,
      },
    };
  },
  props: {
    items: Array,
    defaultTime: Number,
    disable: Boolean,
  },
  methods: {
    toggleInput(): void {
      if (!this.time && typeof this.time !== 'number') {
        this.warn.time = true;
      }
      if (this.newCountry === '') {
        this.warn.country = true;
      }
      if (Object.values(this.warn).every((val) => val === false)) {
        this.showInput = !this.showInput;
        this.$emit('add', [this.newCountry, this.time]);
        this.newCountry = '';
        this.time = null;
        if (this.defaultTime) this.time = this.defaultTime;
      }
    },
  },
  watch: {
    time() {
      this.warn.time = false;
    },
    newCountry() {
      this.warn.country = false;
    },
  },
  created() {
    this.time = this.defaultTime;
  },
});
